import { StrategyDetailsPageGetDocumentRecordQuery } from '@/__generated__/graphql';
import { IOfferingMaterialsAttachments } from '@/components/dealCatalog-page/types';
import { useAuth } from '@/hooks/use-auth';
import { themeVar } from '@/styles/theme';
import { TenantType } from '@trace-8/trace8-schema';
import styled from 'styled-components';
import { DetailsTabSectionBody } from './components/detailsTabSectionBody';
import { DetailsTabZeroState } from './components/detailsTabZeroState';

interface DetailsTabProps {
  offeringMaterialsAttachments: IOfferingMaterialsAttachments[];
  documentRecordId: string | null;
  descriptionSectionFields: StrategyDetailsPageGetDocumentRecordQuery['getDocumentRecord']['fields'];
  showZeroState: boolean;
  openEditDescriptionPage: () => void;
  openForwardDealDocumentsPage: () => void;
}

export const DetailsTab = ({
  offeringMaterialsAttachments,
  documentRecordId,
  descriptionSectionFields,
  showZeroState,
  openEditDescriptionPage,
  openForwardDealDocumentsPage
}: DetailsTabProps) => {
  const { user } = useAuth();

  if (user && user.tenant.type === TenantType.PLATFORM_MANAGER && showZeroState) {
    return (
      <DetailsSection>
        <DetailsTabZeroState addContent={openEditDescriptionPage} />
      </DetailsSection>
    );
  }

  if (!showZeroState) {
    return (
      <DetailsSection>
        <DetailsTabSectionBody
          documentRecordId={documentRecordId}
          data={descriptionSectionFields}
          type="opportunityDetails"
          uploadedFiles={offeringMaterialsAttachments}
          onEditClick={openEditDescriptionPage}
          openForwardDealDocumentsPage={openForwardDealDocumentsPage}
        />
      </DetailsSection>
    );
  }

  return <></>;
};

const DetailsSection = styled.div`
  padding: 40px;
  border-radius: 10px;
  border: 1px solid ${themeVar('border.base')};
  background: ${themeVar('layer.1')};
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 1000px;
  width: 100%;
`;
